// import React, { useState } from "react";
// import "./ChatBox.css";

// function ChatBox() {
//   const [message, setMessage] = useState("");

//   const handleSendMessage = () => {
//     // Handle message sending here
//     setMessage("");
//   };

//   return (
//     <div className="chat-box">
//       <input
//         type="text"
//         value={message}
//         onChange={(e) => setMessage(e.target.value)}
//         placeholder="Ask, write or search anything..."
//       />
//       <button onClick={handleSendMessage}>Send</button>
//       <div className="suggestions">
//         <button>What Products do you recommend?</button>
//         <button>Do you have any current promotions?</button>
//         <button>What are your pricing plans?</button>
//         <button>Can I get a demo or trial?</button>
//         <button>How does your product compare to competitors?</button>
//       </div>
//     </div>
//   );
// }

// export default ChatBox;


import React, { useState, useEffect } from "react";
import "./ChatBox.css";
import { BsFillSendFill } from "react-icons/bs";




function ChatBox({ selectedQuery, onQuerySend, activeDashboard, user }) {
  // Expose inputRef globally for scroll targeting
  useEffect(() => {
    if (typeof window !== "undefined") {
      window.chatInputRef = inputRef;
    }
  }, []);
  const inputRef = React.useRef(null);
  const [message, setMessage] = useState("");
  const [file, setFile] = useState(null);

  // Populate input when user clicks a recent query
  useEffect(() => {
    if (selectedQuery) setMessage(selectedQuery);
  }, [selectedQuery]);

  // Listen for static suggestion selection event
  useEffect(() => {
    const handler = (e) => {
      if (e.detail) setMessage(e.detail);
    };
    window.addEventListener("selectStaticSuggestion", handler);
    return () => window.removeEventListener("selectStaticSuggestion", handler);
  }, []);

  // Send query to parent and store in session
  const handleSendMessage = () => {
    if (message.trim() === "" && !file) return;
    if (onQuerySend) onQuerySend(message);
    // Store query in localStorage/session for Sidebar
    if (user && activeDashboard) {
      window.dispatchEvent(new CustomEvent("newQuery", {
        detail: { query: message, dashboard: activeDashboard, userId: user.id }
      }));
    }
    setMessage("");
    setFile(null);
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  return (
    // <div className="chat-box">
    //   <div className="chat-input-container">
    //     <input
    //       ref={inputRef}
    //       id="file-upload"
    //       type="file"
    //       onChange={handleFileChange}
    //       style={{ display: "none" }}
    //     />
    //     <input
    //       type="text"
    //       value={message}
    //       onChange={(e) => setMessage(e.target.value)}
    //       onKeyDown={(e) => {
    //         if (e.key === "Enter") {
    //           e.preventDefault();
    //           handleSendMessage();
    //         }
    //       }}
    //       placeholder="Ask a question about the selected dashboard..."
    //     />
    //     {/* <label htmlFor="file-upload" className="file-upload-label">
    //         <img src="/assets/upload-icon.png" alt="Send" />
    //     </label> */}
    //     <button
    //       className="send-btn"
    //       onClick={handleSendMessage}
    //       disabled={!message.trim()}
    //     >
    //       <BsFillSendFill />
    //     </button>
    //   </div>
    //   {file && <div className="file-preview">📄 {file.name}</div>}
    // </div>
    <div className="chat-box">
      <div className="chat-input-container">

        {/* LEFT PLUS BUTTON */}
        {/* <button className="icon-btn" onClick={() => inputRef.current.click()}>
          +
        </button> */}

        {/* HIDDEN FILE INPUT */}
        <input
          ref={inputRef}
          type="file"
          onChange={handleFileChange}
          style={{ display: "none" }}
        />

        {/* TEXT INPUT */}
        <input
          type="text"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleSendMessage();
            }
          }}
          placeholder="Ask a question about the selected dashboard..."
        />

        {/* SEND BUTTON */}
        <button
          className="send-btn"
          onClick={handleSendMessage}
          disabled={!message.trim()}
        >
          <BsFillSendFill />
        </button>
      </div>

      {file && <div className="file-preview">📄 {file.name}</div>}
    </div>
  );
}

export default ChatBox;
